__turbopack_context__.v({
  "button": "_3tSIVG_button",
  "error": "_3tSIVG_error",
  "formMessage": "_3tSIVG_formMessage",
  "helperText": "_3tSIVG_helperText",
  "icon": "_3tSIVG_icon",
  "input": "_3tSIVG_input",
  "inputWrapper": "_3tSIVG_inputWrapper",
  "is-invalid": "_3tSIVG_is-invalid",
  "label": "_3tSIVG_label",
  "newsletter": "_3tSIVG_newsletter",
  "redMode": "_3tSIVG_redMode",
});
